import _ from 'lodash'
import { useEffect , useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

import api from '../../services/api'
import useModal from '../../hooks/useModal'

import * as S from './Planner.styles.jsx'
import BasicSelect from '../../components/SelectBoxes'
import { BasicBtn } from '../../components/Buttons'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import Tooltip from '@mui/material/Tooltip'

import { ReactComponent as AddIcon } from '../../assets/images/crud/add_icon.svg'
import { ReactComponent as CalendarIcon } from '../../assets/images/calendar_icon.svg'

export default function SessionalPlan() {
  const { closeModal, openModal } = useModal()
  const [sessionalPlan, setSessionalPlan] = useState()
  const [currentSessionalPlanId, setCurrentSessinalPlanId] = useState()
  const [sessionalPlanList, setSessionalPlanList] = useState([])
  const [sessionalPlanDate, setSessionalPlanDate] = useState()
  const [anchorEl, setAnchorEl] = useState()
  const navigate = useNavigate()

  useEffect(() => {
    api.get(`/sessional-plans/lists`).then(result => {
      const { sessionalPlanList } = result.data
      setSessionalPlanList(sessionalPlanList)
      if (! sessionalPlanList.length) return
      const latest = _.head(sessionalPlanList)
      setCurrentSessinalPlanId(latest.sessionalPlanId)
      setSessionalPlanDate(`${latest.sessionStartOn} ~ ${latest.sessionEndOn}`)
    })
    .catch(e => {
      console.error(e)
      openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
    })
  }, [])


  useEffect(() => {
    if (! currentSessionalPlanId) return
    api.get(`/sessional-plans/${currentSessionalPlanId}`).then(result => {
      const { sessionStartOn, sessionEndOn } = result.data.sessionalPlanInfo
      setSessionalPlanDate(`${sessionStartOn} ~ ${sessionEndOn}`)
      setSessionalPlan(result.data)
    })
    .catch(e => {
      console.error(e)
      openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
    })
  }, [currentSessionalPlanId, sessionalPlanList])

  function handleSessionalPlanChange(e) { setCurrentSessinalPlanId(e.target.value) }

  function clickMoreVert(e) { setAnchorEl(e.currentTarget) }

  function closeMenu() { setAnchorEl(null) }

  async function deleteSessionalPlan() {
    await api.delete(`/sessional-plans/${currentSessionalPlanId}`)
      .then(result => {
        const { sessionalPlanList } = result.data
        setSessionalPlanList(sessionalPlanList)
        setCurrentSessinalPlanId(_.head(sessionalPlanList).sessionalPlanId)
      })
      .catch(e => {
        console.error(e)
        openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
      })
  }

  async function deleteSubject(totalQuantityId) {
    await api.delete(`/sessional-plans/${currentSessionalPlanId}/total-quantities/${totalQuantityId}`)
      .catch(e => {
        console.error(e)
        openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
      })

    await api.get(`/sessional-plans/${currentSessionalPlanId}`)
      .then(result => { setSessionalPlan(result.data) })
      .catch(e => {
        console.error(e)
        openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
      })
  }

  const [contextMenu, setContextMenu] = useState(null)

  const handleClose = () => { setContextMenu(null) }

  function handleContextMenu(event, subject) {
    event.preventDefault()
    setContextMenu(
      ! contextMenu
        ? {
          mouseX: event.clientX + 2,
          mouseY: event.clientY - 6,
          subject,
        }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
          // Other native context menus might behave different.
          // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
        null,
    )
  }
  function drag(e) {
    e.dataTransfer.setData('weeklyQuantity', e.target.id)
  }

  function drop(e) {
    e.preventDefault()
    const target = JSON.parse(e.target.id)
    const weeklyQuantity = JSON.parse(e.dataTransfer.getData('weeklyQuantity'))
    openModal({
      type: 'updateWeeklyDelay',
      props: {
        sessionalPlanId: currentSessionalPlanId,
        totalQuantityId: weeklyQuantity.totalQuantityId,
        weeklyQuantityId: weeklyQuantity.weeklyQuantityId,
        weeklyDelayedAmount: weeklyQuantity.weeklyDelayedAmount,
        targetWeeklyQuantityId: target.weeklyQuantityId,
        targetWeekNum: target.weekNum,
        sessionalPlan,
        setSessionalPlan,
      }
    })
  }

  return (
    <div style={{ margin: '30px', position: 'relative', minHeight: '100vh' }}>
      <h2>Sessional Plan</h2>
      <BasicBtn
        height='40px'
        width='120px'
        onClick={() => openModal({ type: 'updateSessionalPlan', props: { setSessionalPlanList, setCurrentSessinalPlanId } })}
        style={{ position: 'absolute', right: '0px', top: '0px'  }}
      >세셔널 플랜 추가
      </BasicBtn>
      {/* 세셔널 플랜 상단 부분 - 날짜, 세셔널 플랜 추가 및 선택 */}
      {
        sessionalPlanList.length
          ?
          <div style={{ display: 'flex' }}>
            <CalendarIcon/>
            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{sessionalPlanDate}</span>
            <div style={{ display: 'flex', position: 'absolute', right: '0' }}>
              <BasicSelect
                defaultValue={currentSessionalPlanId}
                value={currentSessionalPlanId}
                handleChange={handleSessionalPlanChange}
                itemList={
                  _.map(sessionalPlanList, sessionalPlan => {
                    return {
                      type: sessionalPlan.sessionalPlanId,
                      nameKo: sessionalPlan.sessionName,
                    }
                  })
                }
                name='sessionalPlanList'
                style={{ width: '250px', height: '32px', textAlign: 'center' }}
              />
              <MoreVertIcon
                style={{ cursor: 'pointer'}}
                onClick={clickMoreVert}
              />
              <Menu
                id='fade-menu'
                anchorEl={anchorEl}
                MenuListProps={{ 'aria-labelledby': 'fade-button' }}
                onClose={closeMenu}
                open={Boolean(anchorEl)}
              >
                <MenuItem
                  onClick={() =>  {
                    closeMenu()
                    openModal({
                      type: 'updateSessionalPlan',
                      props: {
                        sessionalPlanId: currentSessionalPlanId,
                        sessionalPlan,
                        setSessionalPlanList,
                        setCurrentSessinalPlanId
                      }
                    })
                  }}
                >
                  <ListItemIcon>
                    <EditIcon fontSize='small' />
                  </ListItemIcon>
                  <ListItemText>수정</ListItemText>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    closeMenu()
                    openModal({
                      type: 'confirm',
                      props: {
                        contents: '정말로 삭제하시겠습니까?',
                        callbackFun: deleteSessionalPlan,
                      }
                    })
                  }}
                >
                  <ListItemIcon>
                    <DeleteIcon fontSize='small' />
                  </ListItemIcon>
                  <ListItemText>삭제</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </div>
          : <></>
      }
      {/* 세셔널 플랜 본문 부분 */}
      <div style={{ marginTop: '30px', overflowX: 'scroll' }}>
        <S.Planner>
          {/* 헤더 - 분류, 영역, session 분량, 주 차 */}
          <tr>
            <S.MainHeader rowSpan='2' width='50px'>분류</S.MainHeader>
            <S.MainHeader rowSpan='2'>
              <span style={{ verticalAlign: 'middle' }}>영역</span>
              <AddIcon
                className='add-icon'
                onClick={() =>
                  openModal({
                    type: 'updateSubject',
                    props: {
                      sessionalPlanId: currentSessionalPlanId,
                      sessionalPlan,
                      setSessionalPlan,
                    }
                  })
                }
              />
            </S.MainHeader>
            <S.MainHeader rowSpan='2'>session 분량</S.MainHeader>
            {
              _.map(sessionalPlan?.weekNumList, wn => {
                return (
                  <S.MainHeader
                    colSpan='3'
                    fontSize='0.75em'
                    width='170px'
                    height='25px'
                    onClick={() => navigate(`${currentSessionalPlanId}/weekly-plan?weekStartOn=${moment(wn.weekStartOn).format('YYYY-MM-DD')}&weekEndOn=${moment(wn.weekEndOn).format('YYYY-MM-DD')}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    {wn.weekNum}주 차 &nbsp;
                    ({moment(wn.weekStartOn).format('MM/DD')} ~ {moment(wn.weekEndOn).format('MM/DD')})
                  </S.MainHeader>
                )
              })
            }
          </tr>
          {/* 헤더 - 주 차별 분량, 완료, 딜레이 */}
          <tr>
            {
              _.map(sessionalPlan?.weekNumList, () => {
                return (
                  <>
                    <S.SubHeader>분량</S.SubHeader>
                    <S.SubHeader>완료</S.SubHeader>
                    <S.SubHeader style={{ backgroundColor: '#FFC8E2' }}>딜레이</S.SubHeader>
                  </>
                )
              })
            }
          </tr>
          {
            _.entries(_.groupBy(_.filter(sessionalPlan?.totalQuantityList, tq => tq.totalQuantityAmount), 'subjectCategory'))
              .map(([subjectCategory,subjectList]) => {
                return (
                  _.map(subjectList, (s, i) => {
                    return (
                      <tr>
                        {/* 분류 */}
                        {
                          i === 0
                            ? <S.TotalPlanData title={subjectCategory} className='update-subject' rowSpan={subjectList.length}  onClick={(event) => handleContextMenu(event, s)}>{subjectCategory}</S.TotalPlanData>
                            :  <></>
                        }
                        {/* 영역 */}
                        <S.TotalPlanData title={s.subject} className='update-subject'  onClick={(event) => handleContextMenu(event, s)}>{s.subject}</S.TotalPlanData>
                        {/* session 분량 */}
                        <Tooltip
                          title={s.totalQuantityMemo}
                          arrow
                          slotProps={{
                            popper: {
                              modifiers: [
                                {
                                  name: 'offset',
                                  options: {
                                    offset: [0, -25],
                                  },
                                },
                              ],
                            },
                          }}>
                          <S.TotalPlanData className='update-subject'  onClick={(event) => handleContextMenu(event, s)}>{`${s.totalQuantityAmount}${s.unit}`}</S.TotalPlanData>
                        </Tooltip>
                        {/* 주 차별 계획 양, 완수 양, 딜레이 양 */}
                        {
                          _.map(s.weeklyQuantityList, (wq, idx) => {
                            return (
                              <>
                                <Tooltip
                                  title={wq.weeklyQuantityMemo}
                                  arrow
                                  slotProps={{
                                    popper: {
                                      modifiers: [
                                        {
                                          name: 'offset',
                                          options: {
                                            offset: [0, -25],
                                          },
                                        },
                                      ],
                                    },
                                }}>
                                  <S.Data
                                    id={`{ "weeklyQuantityId": ${wq.weeklyQuantityId}, "weekNum": ${idx+1} }`}
                                    onClick={() => {
                                      openModal({
                                        type: 'updateQuantity',
                                        props: {
                                          quantity: wq.weeklyQuantityAmount,
                                          completedQuantity: wq.weeklyCompletedQuantityAmount,
                                          memo: wq.weeklyQuantityMemo,
                                          callbackFun: async (data) => {
                                            await api.put(`sessional-plans/${currentSessionalPlanId}/total-quantities/${wq.totalQuantityId}/weekly-quantities/${wq.weeklyQuantityId}`, {
                                              reducedWeeklyQuantity: data.quantity,
                                              weeklyQuantityMemo: data.memo,
                                            }).then(result => {
                                              sessionalPlan.totalQuantityList.forEach(tq => {
                                                if (tq.totalQuantityId === wq.totalQuantityId) tq.weeklyQuantityList = result.data.weeklyQuantityList
                                              })
                                              setSessionalPlan(prev => ({ ...prev }))
                                              closeModal()
                                            })
                                            .catch(e => {
                                              console.error(e)
                                              openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
                                            })
                                          },
                                        }
                                      })
                                    }}
                                    onDrop={drop}
                                    onDragOver={(e) => e.preventDefault()}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {wq.weeklyQuantityAmount}
                                  </S.Data>
                                </Tooltip>
                                <S.Data>{wq.weeklyCompletedQuantityAmount}</S.Data>
                                <S.Data
                                  id={`{ "weeklyQuantityId": ${wq.weeklyQuantityId}, "totalQuantityId": ${wq.totalQuantityId}, "weeklyDelayedAmount": ${wq.weeklyDelayedAmount} }`}
                                  draggable={true}
                                  onDragStart={drag}
                                  style={{ backgroundColor: '#FFEFF5', cursor: 'move' }}
                                >
                                  {wq.weeklyDelayedAmount}
                                </S.Data>
                              </>
                            )
                          })
                        }
                      </tr>
                    )
                  })
                )
              })
          }
          <Menu
            open={contextMenu !== null}
            onClose={handleClose}
            anchorReference='anchorPosition'
            anchorPosition={
              contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined
            }
          >
            <MenuItem
              onClick={() => {
                handleClose()
                openModal({
                  type: 'updateSubject',
                  props: {
                    sessionalPlanId: currentSessionalPlanId,
                    totalQuantity: _.filter(sessionalPlan.totalQuantityList, { totalQuantityId: contextMenu.subject.totalQuantityId })[0],
                    sessionalPlan,
                    setSessionalPlan,
                  }
                })
              }}
            >
              <ListItemIcon>
                <EditIcon fontSize='small'/>
              </ListItemIcon>
              <ListItemText>수정</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose()
                openModal({
                  type: 'confirm',
                  props: {
                    contents: '정말로 삭제하시겠습니까?',
                    callbackFun: deleteSubject,
                    itemId: contextMenu.subject.totalQuantityId,
                  }
                })
              }}
            >
              <ListItemIcon>
                <DeleteIcon fontSize='small'/>
              </ListItemIcon>
              <ListItemText>삭제</ListItemText>
            </MenuItem>
          </Menu>
        </S.Planner>
      </div>
    </div>
  )
}